var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-dropdown-item',{attrs:{"disabled":_vm.disabled}},[_vm._t("label",[_vm._v("label")]),_c('ul',{staticClass:"sub-dropdown"},[_vm._t("default")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }